export default __webpack_public_path__ + "static/media/collapse.70458ba1.svg";